var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data_loaded)?_c('section',{staticClass:"legal-pages",domProps:{"innerHTML":_vm._s(_vm.privacy_policy)}}):_c('div',_vm._l((Array.from(new Array(20))),function(loading_el,index){return _c('div',{key:index,staticClass:"element-loading"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }